import {INPUT_TYPES} from "../constants/inputs";

export default class InputController {
    static init(){
        this.state = this.defaultState();
        this.providers = [];
        this.eventTarget = new EventTarget();
    }

    static defaultState(){
        return {
            [INPUT_TYPES.LEFT]: false,
            [INPUT_TYPES.RIGHT]: false,
            [INPUT_TYPES.UP]: false,
            [INPUT_TYPES.DOWN]: false,
            [INPUT_TYPES.JUMP]: false,
        }
    }

    static registerProvider(provider){
        this.providers.push(provider);
        provider.addEventListener("keyup", (ev) => {
            const event = new CustomEvent("keyup", {detail: ev.detail});
            this.eventTarget.dispatchEvent(event);
        })
    }

    static getState(){
        this.state = this.defaultState();
        this.providers.forEach(p => {
            this.state = {
                ...this.state,
                ...p.getState()
            }
        })
        return this.state;
    }
}